import React from "react";


function FormFieldError(props) {
    return  (
        <>
            {(props.state.errors !== undefined && props.state.errors[props.field] !== undefined) &&
                <div className={"form-field-error"}>
                    {props.state.errors[props.field]}
                </div>
            }

        </>
    );
}

export { FormFieldError };